import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { CompareserviceService } from '../compareservice.service';
import { ConfigPopupComponent } from '../config-popup/config-popup.component';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';

@Component({
  selector: 'app-submit',
  templateUrl: './submit.component.html',
  styleUrls: ['./submit.component.scss']
})
export class SubmitComponent implements OnInit {
  startDate = new FormControl(new Date());
  endDate = new FormControl(new Date());

  instanceList: any;
  selectedInstance: any;
  targetInstance: any;
  public projectId: string;
  public projectName: string;
  public batchKey: string = null;
  public options: any;
  public tracks = [];
  public configData = [];
  public showArray = [];
         fromTable: any;
         batchKeyDetails: any;
  public submitBtnEnable: boolean;
  public progressBarName = 'submit';
  public itemNumber = 1;
  public progressBarArray1 = [{ name: "select", src: 'assets/complete.png', index: 0 },
  { name: "submit", src: 'assets/submit.png', index: 1 },
  { name: "compare", src: 'assets/Vector.png', index: 2 },
  ];
  instanceListDuplicate: any;
  instanceListTarget: any;
  constructor(public dialog: MatDialog,
    private compareService: CompareserviceService,
    private router: Router,
    private route: ActivatedRoute, private notification: NotificationService) { }

  ngOnInit(): void {
    if (this.compareService.projId == null) {
      this.router.navigate([""], { relativeTo: this.route });
    } else {
      this.fromTable = this.compareService.fromTable;
      this.instanceList = this.compareService.instanceList;
      this.instanceListDuplicate = this.compareService.instanceList;
      this.selectedInstance = this.compareService.sourceInstance;
      this.instanceListTarget = this.instanceListDuplicate.filter(
        i => i.INSTANCE !== this.compareService.sourceInstance.INSTANCE);
      this.targetInstance = this.compareService.targetInstance;

      this.batchKeyDetails = this.compareService.batchKeyDetails;
      this.batchKey = this.compareService.batchKey;
      this.projectId = this.compareService.projId;
      if (this.fromTable) {
        this.tracks = this.compareService.tracksFromTable;
        this.submitBtnEnable = this.getLineItemsEdit(this.batchKeyDetails).length > 0 ? true : false;
      } else {
        this.tracks = this.compareService.configObj.tracks;
        this.configData = this.compareService.configObj.configData;
        this.submitBtnEnable = this.getLineItems(this.configData).length > 0 ? true : false;
      }
      this.setShowArray();
    }
  }

  setShowArray() {
    this.tracks.forEach((val, index) => {
      this.showArray[index] = false;
    });
  }

  onInstanceChangeAtSource(instance) {
    if (instance == null) {
      this.targetInstance = null;
      this.instanceListTarget = this.instanceListDuplicate;
    } else {
      this.instanceListTarget = this.instanceListDuplicate.filter(
        i => i.INSTANCE !== instance.INSTANCE);
      if (this.selectedInstance?.INSTANCE === this.targetInstance?.INSTANCE) {
        this.targetInstance = null;
      }
      this.compareService.sourceInstance = this.selectedInstance;
      this.compareService.targetInstance = this.targetInstance;
      if (this.fromTable) {
        const instanceValues = {
          sourceInstance: this.selectedInstance.INSTANCE,
          targetInstance: this.targetInstance.INSTANCE
        };
        this.compareService.instanceData = instanceValues;
      }
    }
  }


  onInstanceChangeAtTarget(instance) {
    this.compareService.sourceInstance = this.selectedInstance;
    this.compareService.targetInstance = this.targetInstance;
    if (this.fromTable) {
      const instanceValues = {
        sourceInstance: this.selectedInstance.INSTANCE,
        targetInstance: this.targetInstance.INSTANCE
      };
      this.compareService.instanceData = instanceValues;
    }
  }

  configPopUp(evt, data) {
    evt.stopPropagation();
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.compareService.sourceInstance = this.selectedInstance;
      this.compareService.targetInstance = this.targetInstance;
      this.compareService.instanceList = this.instanceList;
      if (result.savedData) {
        this.setSelectedconfigData(result, this.configData);
        this.compareService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
        this.submitBtnEnable = this.getLineItems(this.configData).length > 0 ? true : false;
      } else {
        this.compareService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
      }
    });
  }

  configPopUpEdit(evt, data) {
    evt.stopPropagation();
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.compareService.instanceName = this.selectedInstance;
      this.compareService.instanceList = this.instanceList;
      this.compareService.targetInstance = this.instanceListTarget;
      if (result.savedData) {
        this.setSelectedconfigDataEdit(result, this.batchKeyDetails);
        this.compareService.tracksFromTable = this.tracks;
          this.compareService.batchKeyDetails = this.batchKeyDetails;
        this.submitBtnEnable = this.getLineItemsEdit(this.batchKeyDetails).length > 0 ? true : false;
      } else {
        this.compareService.tracksFromTable = this.tracks;
          this.compareService.batchKeyDetails = this.batchKeyDetails;
      }
    });
  }

  setSelectedconfigDataEdit(result, configObj) {
    const selConfigData = result.selectedConfigData;
    configObj.forEach((element, index) => {
      if (selConfigData.track === element.track && selConfigData.application === element.application && selConfigData.applicationshortcode === element.applicationshortcode) {
        this.batchKeyDetails.splice(index, 1, selConfigData);
      }
    });
  }


  setSelectedconfigData(result, configObj) {
    const selConfigData = result.selectedConfigData;
    configObj.forEach((element, index) => {
      if (selConfigData.TRACK === element.TRACK && selConfigData.APPLICATION_SHORT_CODE === element.APPLICATION_SHORT_CODE) {
        this.configData.splice(index, 1, selConfigData);
      }
    });
  }

  onSubmit() {
    const body = this.onConfigSubmit();
    this.compareService.onConfigSubmit(body).subscribe((res) => {
      this.batchKey = res.Batch_Key;
      this.compareService.batchKey = this.batchKey;
      if (res.Batch_Key) {
        const dialogRef = this.dialog.open(InfoPopupComponent, {
          width: "917px",
          height: "220px",
          data: {
            type: 'Task Status',
            mess: ` Batch Key ${res.Batch_Key}  :<b> New</b>`
          }
        });

        dialogRef.afterClosed().subscribe((result) => {
          if ((result = "ok")) {
            this.compareService.tabval.next("compare");
            this.router.navigate(["../compare"], { relativeTo: this.route });  
          }
        });
      } else {
        alert(res.Result);
      }
    },
      (error) => {
        this.notification.showError('Something went wrong!');
      });
  }

  onConfigSubmit() {
    let body;
    if (this.fromTable) {
      body = {
        batchkey: this.batchKeyDetails[0].batchkey,
        projectname: this.batchKeyDetails[0].projectname,
        requestedby: this.batchKeyDetails[0].requestedby,
        filesharepath: this.batchKeyDetails[0].filesharepath,
        requesttype: DconConfigAPI.API_VARIABLES.Request_Type_Compare,
        extracttype: DconConfigAPI.API_VARIABLES.Extract_Type_SQL,
        targetinstance: this.targetInstance.INSTANCE,
        sourceinstance: this.selectedInstance.INSTANCE,
        instanceid: this.selectedInstance.INSTANCE_ID.toString(),
        targetinstanceid: this.targetInstance.INSTANCE_ID.toString(),
        LineItems: this.getLineItemsEdit(this.batchKeyDetails),
        comparisonType: 'Instance'
      };
    } else {
      body = {
        batchkey: this.compareService.batchKey ? this.compareService.batchKey : "",
        projectname: this.projectId,
        requestedby: this.compareService.requestedBy,
        targetinstance: this.targetInstance.INSTANCE,
        sourceinstance: this.selectedInstance.INSTANCE,
        filesharepath: this.compareService.getfileSharePath(),
        requesttype: DconConfigAPI.API_VARIABLES.Request_Type_Compare,
        extracttype: DconConfigAPI.API_VARIABLES.Extract_Type_SQL,
        instanceid: this.selectedInstance.INSTANCE_ID.toString(),
        targetinstanceid: this.targetInstance.INSTANCE_ID.toString(),
        LineItems: this.getLineItems(this.configData),
        comparisonType: 'Instance'
      };
    }
    return body;
  }

  getLineItems(configData) {
    const data = [];
    configData?.forEach((element) => {
      if (element.TASK != null && element.saveStatus) {
        element.TASK.forEach((ele) => {
          if (ele.selectStatus === "y" || ele.selectStatus === "Y") {
            const trackObj = {
              track: element.TRACK,
              applicationshortcode: element.APPLICATION_SHORT_CODE,
              taskname: ele.TASK_NAME,
              taskcode: ele.TASK_CODE
            };
            data.push(trackObj);
          }
        });
      }
    });
    return data;
  }

  getLineItemsEdit(configData) {
    const data = [];
    configData?.forEach((element) => {
      if (element.linedetail != null && element.linedetail?.length > 0) {
        element.linedetail.forEach((ele) => {
          if (ele.taskselected === "Y") {
            const trackObj = {
              track: element.track,
              applicationshortcode: element.applicationshortcode,
              taskname: ele.taskname,
              taskcode: ele.taskcode
            };
            data.push(trackObj);
          }
        });
      }
    });
    return data;
  }

}


